import React from 'react';
import BackgroundObject from 'game/scenes/test/BackgroundObject';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function BackgroundObjectPage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [BackgroundObject],
            physics: {
              arcade: {
                gravity: { y: 0 },
              },
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
